// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon__KWdDk","count":"count__3IjI_","unread":"unread__HznT3","email":"email__3tPyM"};